import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/services/http/http.service';

export interface StreamerData {
	HttpsPort?: number; // Port number for HTTPS, e.g., 443
	address: string; // Address of the streamer, e.g., "st2-dev.aldar.com"
	domain: string; // Domain name, e.g., "st2-dev.aldar.com"
	kickUrl: string; // URL for kicking all users, e.g., "https://st2-dev.aldar.com/kickAllUsersFromSS/"
	lastPingReceived: number; // Timestamp of the last ping received, e.g., 1723550197781
	numConnectedClients: number; // Number of connected clients, e.g., 0
	port: number; // Port number for HTTP, e.g., 80
	ready: boolean; // Readiness status, e.g., true
}
@Component({
	selector: 'app-version-details',
	templateUrl: './version-details.component.html',
	styleUrls: ['./version-details.component.sass'],
})
export class VersionDetailsComponent implements OnInit {
	isLoading: boolean = true;
	beVersion: string = '0.00';
	feVersion: string = environment.version;
	elasticHealth: string = '';
	loginBg: string = './assets/images/post-login-BG@2x.png';
	appLogo: string = './assets/images/aldar-properties-logo.png';

	constructor(private _http: HttpService) {}

	ngOnInit(): void {
		this.fetchVersionDetails();
	}
	getColor(value: string): string {
		// Define color logic based on the trimmed value
		switch (value.toLowerCase()) {
			case 'red':
				return 'red';
			case 'green':
				return 'DarkGreen';
			case 'yellow':
				return 'orange';
			default:
				return 'black'; // Default color
		}
	}

	fetchVersionDetails(): void {
		//ES API version
		this._http.getVersionDetails().subscribe(
			(data: any) => {
				this.beVersion = data.version;
				this.elasticHealth = data.elasticHealth?.status ?? '';
			},
			(error: any) => {
				console.error('Error fetching version details:', error);
				this.isLoading = false;
			},
		);
	}
}
